import PropTypes from 'prop-types';
import compose from '../hoc/compose';
import template from './panelHeaderIllustration.jsx';
var PanelHeaderIllustration = template;
PanelHeaderIllustration.displayName = 'PanelHeaderIllustration';
PanelHeaderIllustration.propTypes = {
  blueStripHeight: PropTypes.number
};
PanelHeaderIllustration.defaultProps = {
  blueStripHeight: 90
};
export default compose(PanelHeaderIllustration);